module.exports = __webpack_public_path__ + "img/multiplier3_freespins.5ae70d0b.png";